export const LOADING = 'PAGE/LOADING'